import "./style.css";
import { useEffect, useState } from "react";
import { Partner } from "../../interfaces/partner";
import { MockPartners } from "../../mocks/partners";
import CardPartner from "../../components/cardPartner";
import OwlCarousel from "react-owl-carousel";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function HomeMarcas(){
    const [partners, setPartners] = useState<Partner[]>();

    useEffect(() => {
        fetchPartners();
    }, []);

    const fetchPartners = async () => {
        let lista: Partner[] = await MockPartners;
        setPartners(lista);
    }

    const options = {
        margin: 30,
        responsiveClass: true,
        nav: false,
        dots: false,
        autoplay: true,
        navContainerClass: `owl-nav`,        
        navClass: ['owl-prev','owl-next'],
        controlsClass: 'owl-controls',
        smartSpeed: 1000,     
        autoplayTimeout: 3000,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:2
            },
            900:{
                items:2
            },
            1000:{
                items:3
            }
        }
    };

    const renderPartners = () => partners?.map((v, i) => <CardPartner data={v} key={i}></CardPartner>)

    return (
        <section className="ourPartners pt-5">
                <div className="sectionTitle">
                    <h3 className="text-center mb-4 fw-bold">Nuestras alianzas</h3>
                </div>
                <div className="carousel__container">  
                    <div className="container py-2">
                        {partners? <OwlCarousel className='owl-theme' loop {...options}>
                            {renderPartners()}
                        </OwlCarousel>: ''}
                    </div>                  
                </div>
        </section>
    )
}